import {connect, useSelector} from "react-redux";
import React, {useEffect, useState} from "react";
import Loading from "../../common/Loading";
import {AgGridReact} from "ag-grid-react";
import * as Global from "../../common/Global";
import * as api from "../../../api/api";
import {Switch} from "@headlessui/react";
import {getGameListAll, getMinigameHoleList, saveMinigameHoleList} from "../../../api/api";
import {CModal, CModalBody, CModalHeader, CModalTitle} from "@coreui/react";
import UserRegister from "../user/UserRegister";
import MinigameCartSetting from "./MinigameCartSetting";
import { isGameEnabled } from "../../../config/menuConfig";

const GameUseSetting = (props) => {
    const {user} = useSelector((props) => props.account);
    const [loading, setLoading] = useState(false)
    const [dataList, setDataList] = useState([])
    const [minigameCartModal, setMinigameCartModal] = useState(false)
    const [selectedGameCode, setSelectedGameCode] = useState(null)
    const [minigameHoleData, setMinigameHoleData] = useState([])

    const handleMinigameCartSetting = async (gameCode) => {
        setLoading(true);
        try {
            const result = await getMinigameHoleList(user.companyCode, gameCode);
            if (result.status === 200) {
                const {data, success} = result.data
                if (success) {
                    setMinigameHoleData(data);
                    setSelectedGameCode(gameCode);
                    setMinigameCartModal(true);
                }
            }
        } catch (error) {
            console.error("미니게임 홀 목록 조회 중 오류:", error);
            alert("미니게임 홀 목록 조회 중 오류가 발생했습니다.");
        } finally {
            setLoading(false);
        }
    };

    const handleMinigameCartSave = (updatedSettings) => {
        // 저장 로직 구현
        api.saveMinigameHoleList(updatedSettings).then(result => {
            const {data, status, statusText} = result
            if (status === 200) {
                setMinigameCartModal(false);
            }
        })
            .catch(ex => {})
            .finally(() => setLoading(false))
    };

    const [columnDefs] = useState([
        {field: 'gameDiv', headerName: "게임종류", width: 120, valueFormatter: e => Global.exportGameDiv(e.value), cellClass: 'static-class'},
        {
            field: 'sortOrder', 
            headerName: '순서', 
            width: 100, 
            cellClass: 'flex items-center justify-center',
            cellRenderer: (params) => {
                return (
                    <div className="flex items-center justify-center h-full">
                        <input
                            type="number"
                            min="1"
                            className="w-16 text-center border border-gray-300 rounded-lg px-2 py-1 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 shadow-sm hover:shadow-md transition-all duration-200"
                            value={params.value}
                            onChange={(e) => {
                                const newValue = parseInt(e.target.value) || 1;
                                const currentGameCode = params.data.gameCode;
                                setDataList(prevList => 
                                    prevList.map(item => 
                                        item.gameCode === currentGameCode 
                                            ? {...item, sortOrder: newValue}
                                            : item
                                    )
                                );
                            }}
                        />
                    </div>
                );
            }
        },
        {field: 'gameName', headerName: '게임 이름', width: 180},
        {
            field: 'useYn',
            headerName: "사용여부",
            width: 100,
            cellClass: 'flex items-center justify-center',
            cellRenderer: (params) => {
                const isChecked = params.value === 1;
                return (
                    <div className="flex items-center justify-center h-full">
                        <Switch
                            checked={isChecked}
                            onChange={(checked) => {
                                const newValue = checked ? 1 : 0;
                                const currentGameCode = params.data.gameCode;
                                setDataList(prevList => 
                                    prevList.map(item => 
                                        item.gameCode === currentGameCode 
                                            ? {...item, useYn: newValue}
                                            : item
                                    )
                                );
                            }}
                            className={`${
                                isChecked ? 'bg-gradient-to-r from-blue-600 to-indigo-600' : 'bg-gray-300'
                            } relative inline-flex h-7 w-12 items-center rounded-full transition-all duration-300 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 shadow-lg hover:shadow-xl`}
                        >
                            <span
                                className={`${
                                    isChecked ? 'translate-x-6' : 'translate-x-1'
                                } inline-block h-5 w-5 transform rounded-full bg-white shadow-lg transition-all duration-300 ease-in-out`}
                            />
                        </Switch>
                    </div>
                );
            }
        },
        {
            headerName: '베팅설정', 
            width: 150, 
            cellClass: 'static-class',
            cellRenderer: params => {
                if (params.data.gameDiv === 'minigame') {
                    return (
                        <button
                            className="px-4 py-2 bg-gradient-to-r from-purple-500 to-pink-500 text-white text-sm font-semibold rounded-lg shadow-md hover:shadow-lg hover:scale-105 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2"
                            onClick={() => handleMinigameCartSetting(params.data.gameCode)}
                        >
                            베팅설정
                        </button>
                    );
                }
                return null;
            }
        }
    ])

    useEffect(() => {
        search()
    }, [])

    const search = () => {
        setLoading(true)
        api.getGameListAll(user.companyCode).then(result => {
            const {data, status, statusText} = result
            if (status === 200) {
                const allowed = (data || []).filter(item => {
                    const div = item.gameDiv;
                    if (div === 'sport' || div === 'sports') return isGameEnabled('sports');
                    if (div === 'minigame') return isGameEnabled('minigame');
                    if (div === 'casino') return isGameEnabled('casino');
                    if (div === 'slot') return isGameEnabled('slot');
                    return true;
                });
                setDataList(allowed)
            } else {
                window.alert(statusText)
            }
        })
            .catch(ex => {})
            .finally(() => setLoading(false))
    }

    const save = () => {
        if (!window.confirm("저장하시겠어요?")) return;

        setLoading(true)
        api.saveGameList(dataList).then(result => {
            const {data, status, statusText} = result
            if (status === 200) {
                window.alert(data.message)
                search()
            } else {
                window.alert(statusText)
            }
        })
            .catch(ex => {})
            .finally(() => setLoading(false))
    }

    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100 p-6">
            {loading ? <Loading /> : null}
            
            {/* Breadcrumb 헤더 */}
            <div className="flex flex-row gap-2 mb-6 items-center">
                <span className="font-bold text-zinc-800">⌘</span>
                <span className="text-sm text-zinc-500">설정 관리</span>
                <span className="text-sm text-blue-500">-</span>
                <span className="text-sm font-bold">게임 사용 설정</span>
            </div>

            {/* 메인 컨테이너 */}
            <div className="bg-gradient-to-br from-white to-blue-50 rounded-3xl shadow-xl border border-blue-100 hover:shadow-2xl transition-all duration-300">
                {/* 헤더 섹션 */}
                <div className="p-6 border-b border-gray-200">
                    <div className="flex items-center justify-between">
                        <div className="flex items-center gap-3">
                            <div className="w-2 h-8 bg-gradient-to-b from-blue-500 to-indigo-600 rounded-full"></div>
                            <h1 className="text-2xl font-bold text-gray-800">게임 사용 설정</h1>
                        </div>
                        <button 
                            className="px-6 py-3 bg-gradient-to-r from-blue-600 to-indigo-600 text-white font-bold rounded-xl shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-300" 
                            onClick={save}
                        >
                            설정 저장
                        </button>
                    </div>
                </div>

                {/* AG-Grid 컨테이너 */}
                <div className="p-6">
                    <div className="ag-theme-alpine h-[calc(100vh-300px)] rounded-xl overflow-hidden">
                        <AgGridReact
                            rowHeight={50}
                            headerHeight={48}
                            enableCellTextSelection={true}
                            defaultColDef={Global.defaultColDef}
                            columnDefs={columnDefs}
                            rowData={dataList}
                        />
                    </div>
                </div>
            </div>

            {/* 미니게임 카트 설정 모달 */}
            <CModal size={"lg"} backdrop={"static"} alignment={"center"} visible={minigameCartModal}
                    onClose={() => setMinigameCartModal(false)}>
                <CModalHeader>
                    <CModalTitle>미니게임 베팅카트 설정</CModalTitle>
                </CModalHeader>
                <CModalBody>
                    <MinigameCartSetting 
                        data={minigameHoleData}
                        onSave={handleMinigameCartSave}
                    />
                </CModalBody>
            </CModal>
        </div>
    )
}

const mapStateToProps = (state) => {
    const {account, store} = state;
    return {
        account, store
    }
}

export default connect(mapStateToProps, null)(GameUseSetting);